import { all, call, put, takeEvery } from "redux-saga/effects";

import {
    PASSWORD_RESET_EMAIL_SAVE,
    PasswordResetEmailSaveAction,
    passwordResetEmailSaveApi,
} from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmail.actions";
import { FORM_NAME } from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmailForm";
import { XHRAction, XHRFormError, normalizeError } from "@/mk2/helpers/api";
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from "@/mk2/helpers/form";
import { getLogger } from "@/mk2/logger";
import { HistoryAction } from "@/mk2/services/browserHistory";
import { users_api_email_password_reset_url } from "@/mk/urls/functions";

const logger = getLogger("users/PasswordResetEmail.sagas");

interface ApiResponseSave {
    body: {};
}

function* save({
    usernameOrEmail,
    xhr,
    location,
    routeNavigate,
}: PasswordResetEmailSaveAction & XHRAction & HistoryAction) {
    yield put(passwordResetEmailSaveApi.request(usernameOrEmail));

    try {
        const response: ApiResponseSave = yield call(() =>
            xhr.post(users_api_email_password_reset_url(), {
                username_or_email: usernameOrEmail.trim(),
            }),
        );

        yield handleXHRFormSuccessSaga(FORM_NAME, routeNavigate);
        yield put(passwordResetEmailSaveApi.success(usernameOrEmail));
    } catch (error) {
        yield handleXHRFormErrorSaga(FORM_NAME, error as XHRFormError, logger);
        yield put(passwordResetEmailSaveApi.failure(usernameOrEmail, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeEvery(PASSWORD_RESET_EMAIL_SAVE, save)]);
}
